<template>
  <NoteBox :header="headerText" class="my-16 mx-10">
    <!-- eslint-disable-next-line vue/no-v-html -->
    <p class="text-small mt-8" v-html="bodyText" />
  </NoteBox>
</template>

<script lang="ts">
import pluralize from 'pluralize';
import NoteBox from '@/components/note_box/NoteBox.vue';

export default {
  name: 'ColumnTips',
  components: { NoteBox },
  props: {
    currentTab: {
      type: String,
      required: true,
    },
    numberOfApplicants: {
      type: Number,
      required: true,
    },
  },
  computed: {
    isBasic(): boolean {
      return this.$store.getters['account/getAccount']?.isBasic() || false;
    },
    isReceived(): boolean {
      return this.currentTab === 'RECEIVED';
    },
    isInterested(): boolean {
      return this.currentTab === 'INTERESTED';
    },
    headerText(): string {
      if (this.isBasic && this.isReceived && this.numberOfApplicants > 0) {
        return "Great news–you've got applicants!";
      }
      if (this.isBasic && this.isReceived) {
        return 'Organize Your Applicants';
      }
      if (this.isInterested) {
        return 'Managing Applicants Tip';
      }
      return 'Awaiting Your Response';
    },
    bodyText(): string {
      if (this.isBasic && this.isReceived && this.numberOfApplicants > 0) {
        return `${this.numberOfApplicants} quality ${pluralize('caregiver', this.numberOfApplicants)} ${pluralize('is', this.numberOfApplicants)} interested in your job. <a href="/upgrade/pricing" class="text-primary underline">Upgrade to Premium</a> to respond right away—top sitters book fast.`;
      }
      if (this.isBasic && this.isReceived) {
        return `If received applicants don't match your needs, mark as not a fit. For those you're excited about, <a href="/upgrade/pricing" class="text-grey-clickable underline">upgrade to Premium</a> to reply.`;
      }
      if (this.isInterested) {
        return `All applicants you replied to will also appear in <a href="/messages" class="text-grey-clickable underline">your messages</a>`;
      }
      return 'Be respectful and reply to all your applicants quickly to start the conversation';
    },
  },
};
</script>
